"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommentAreaTitle = function CommentAreaTitle(_ref) {
  var num_comments = _ref.num_comments,
      commentsTitle = _ref.commentsTitle;
  return _react2.default.createElement(
    "div",
    { className: "panestack-title" },
    _react2.default.createElement(
      "span",
      { className: "title" },
      commentsTitle || "all " + (num_comments ? num_comments : "") + " comments"
    )
  );
};

exports.default = CommentAreaTitle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/components/CommentAreaTitle.js
// module id = 301
// module chunks = 0